// App-wide environment config shared by web and native (Capacitor) builds.

// Canonical public web origin. Used for user-facing URLs that must NOT point at the
// native localhost origin — referral share links and external return URLs (Stripe
// checkout). On web this is also where checkout returns. Overridable at build time.
export const PUBLIC_WEB_URL = (process.env.REACT_APP_PUBLIC_WEB_URL || "https://qcap.es").replace(/\/$/, "");

// True when running inside a Capacitor native WebView. Capacitor injects a global
// `window.Capacitor` in native contexts; reading it here keeps this module free of a
// hard dependency on @capacitor/core, so the plain web bundle is unaffected.
export function isNative() {
    try {
        const cap = typeof window !== "undefined" ? window.Capacitor : null;
        return !!(cap && typeof cap.isNativePlatform === "function" && cap.isNativePlatform());
    } catch {
        return false;
    }
}

// True on touch-primary devices (native app or a phone/tablet browser with no fine
// pointer). Used to suppress input `autoFocus`, which on touch pops the soft keyboard
// unprompted and covers the form before the user has chosen what to enter.
export function isTouchDevice() {
    try {
        if (isNative()) return true;
        return typeof window !== "undefined" && typeof window.matchMedia === "function"
            && window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    } catch {
        return false;
    }
}
